"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getComponentConfig = exports.ListComponentConfigDefinition = exports.ComponentConfigDefinition = void 0;

var _types = require("../../types");

var _validation = require("../../types/validation");

var _componentConfigs = require("./componentConfigs");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ComponentRuleDefinition = _flowRuntime["default"].tdz(function () {
  return _validation.ComponentRuleDefinition;
});

var InheritedComponentValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedComponentValidation;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var OptionDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].type("ComponentConfigDefinition", _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string()), _flowRuntime["default"].property("subComponents", _flowRuntime["default"].array(_flowRuntime["default"].ref(ComponentElementDefinition)), true), _flowRuntime["default"].property("fields", _flowRuntime["default"].array(_flowRuntime["default"].ref(FieldElementDefinition)), true), _flowRuntime["default"].property("validation", _flowRuntime["default"].array(_flowRuntime["default"].ref(ComponentRuleDefinition)), true), _flowRuntime["default"].property("inheritedComponentValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedComponentValidation)), true)));

exports.ComponentConfigDefinition = ComponentConfigDefinition;

var ListComponentConfigDefinition = _flowRuntime["default"].type("ListComponentConfigDefinition", _flowRuntime["default"].spread(ComponentConfigDefinition, _flowRuntime["default"].object(_flowRuntime["default"].property("defaultItems", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition))))));

exports.ListComponentConfigDefinition = ListComponentConfigDefinition;

var componentConfigs = function componentConfigs() {
  return [_componentConfigs.addressConfig, _componentConfigs.ambassadorConfig, _componentConfigs.conditionConfig, _componentConfigs.contentConfig, _componentConfigs.discoveryMethodConfig, _componentConfigs.donationConfig, _componentConfigs.educationConfig, _componentConfigs.fieldsetConfig, _componentConfigs.headerConfig, _componentConfigs.heightWeightConfig, _componentConfigs.heightSelectConfig, _componentConfigs.listWithOtherConfig, _componentConfigs.marketingPreferencesConfig, _componentConfigs.medicalHistoryConfig, _componentConfigs.motivationForJoiningConfig, _componentConfigs.occupationConfig, _componentConfigs.personalDetailsConfig, _componentConfigs.personCategoryConfig, _componentConfigs.phoneNumberConfig, _componentConfigs.preQualifiersConfig, _componentConfigs.reasonForDonatingConfig, _componentConfigs.receivedBloodTransfusionConfig, _componentConfigs.refusedBloodDonorConfig, _componentConfigs.weightSelectConfig];
};

var getComponentConfig = function getComponentConfig(component) {
  return componentConfigs().find(function (c) {
    return c.type === component.type;
  });
};

exports.getComponentConfig = getComponentConfig;